import { combineReducers } from 'redux';
import multipleCompanies from './multipleCompanies.reducer';

const reducer = combineReducers({
	multipleCompanies
});

export default reducer;